<div class="tabbed-header">
  <div>
    <app-breadcrumb></app-breadcrumb>
  </div>
  <!-- <app-breadcrumb></app-breadcrumb> -->

</div>



<!-- Add this after the tabbed-header div -->
<div class="filter-container" style="display: none;">
  <div class="create-ticket-button-container" style="margin-bottom: 1rem;">
    <div>
      <button #filterButton (click)="toggleFilterBox()" class="filterbtn">
        Filters <span *ngIf="activeFilterCount > 0">({{ activeFilterCount }})</span>
      </button>
    </div>
    <div class="tags" [class.tags--active]="selectedUser || selectedDateRange">
      <div *ngIf="selectedUser || selectedDateRange">
        <span *ngIf="selectedUser" class="filter-tag" style="display: none;">
          User: {{ selectedUser }}
          <button (click)="clearUserFilter()" class="tag-close-btn">✕</button>
        </span>
        <span *ngIf="selectedDateRange" class="filter-tag">
          Date: {{ selectedDateRange }}
          <button (click)="clearDateFilter()" class="tag-close-btn">✕</button>
        </span>
      </div>
    </div>
  </div>

  <div *ngIf="showFilterBox" class="box1" style="margin-bottom: 1rem;">
    <div class="ins2">
      <!-- User Filter -->
      <div>
        <label>User</label>
        <input type="text" [(ngModel)]="userSearch" placeholder="Search user..." (input)="onUserSearch()" />
        <ul *ngIf="filteredUserList.length > 0" class="options">
          <li *ngFor="let user of filteredUserList" (click)="selectUser(user)">
            {{ user }}
          </li>
        </ul>
      </div>
      <!-- Date Filter -->
      <div style="margin-top: 1rem;">
        <label>Date</label>
        <div>
          <input type="radio" name="dateType" [(ngModel)]="dateFilterType" value="exact" (change)="resetDateInputs()" />
          Exact
          <input type="radio" name="dateType" [(ngModel)]="dateFilterType" value="range" (change)="resetDateInputs()"
            style="margin-left: 1rem;" /> Range
        </div>
        <div *ngIf="dateFilterType === 'exact'" style="margin-top: 0.5rem;">
          <input type="date" [(ngModel)]="exactDate" />
        </div>
        <div *ngIf="dateFilterType === 'range'" style="margin-top: 0.5rem;">
          <input type="date" [(ngModel)]="startDate" /> to
          <input type="date" [(ngModel)]="endDate" />
        </div>
      </div>
      <div class="filter-buttons" style="margin-top: 1rem;">
        <button (click)="clearAllFilters()">Clear</button>
        <button (click)="applyFilters()">Apply Filter</button>
      </div>
    </div>
  </div>
</div>

<div class="timeline" *ngIf="data; else elseBlock">
  <div *ngFor="let objectItem of data | keyvalue; index as i" style="display: flex; flex-direction: column">
    <!-- Only show date template if there are real changes in this group -->
    <ng-container *ngIf="hasGroupRealChanges(objectItem)">
      <div [ngClass]="isPair(i) === true ? 'dateTemplateRight' : 'dateTemplateLeft'">
        <span class="date-time-set">{{ formatGroupKeyDateTime(objectItem?.key) }}</span>
        <div *ngIf="getCreatedUserName(objectItem.value)" class="created-user-display">
    <span class="user_name">{{ capitalizeFirstLetter(getCreatedUserName(objectItem.value)) }}</span>
  </div>
        
        <div *ngIf="objectItem?.key?.split(':')[0]">
          <span class="user_name">{{ capitalizeFirstLetter(objectItem?.key?.split(':')[0]) }}</span>
        </div>

      </div>
    </ng-container>

    <div *ngFor="let item of objectItem.value">
      <ng-container *ngIf="(item.title !== 'Created' || shouldShowCreatedSection(objectItem)) && (item.title !== 'Updated' || hasAnyRealChanges(item.content))">
        <div class="container left" [ngClass]="isPair(i) === true ? 'left' : 'right'">
          <div class="inner">
            <div class="head">
              <div class="title">
                <!-- Check if content should be shown as Created instead of Updated -->
                <ng-container *ngIf="item.title === 'Updated' && shouldShowUpdatedAsCreated(item.content); else normalTitle">
                  Created
                </ng-container>
                <ng-template #normalTitle>
                  {{ item.title }}
                </ng-template>
              </div>
            </div>
            <div class="body">
              <p *ngIf="item.title === 'Created'; else elseBlock" [innerHTML]="getSafeCreatedContent(item.content)"></p>

              <ng-template #elseBlock>
                <!-- Inside your ng-template #elseBlock -->
                <ng-container *ngFor="let con of item.content; let idx = index">

                  <div class="change-info" *ngIf="hasChanges(con.oldValue, con.newValue,con.label)">
                   

                    <!-- OLD VALUE -->
                   <div *ngIf="con.oldValue !== null && con.oldValue !== undefined && con.oldValue !== '' && !(isPasswordField(con.label) && item.title === 'Updated')">
  <span class="label">Old Value: </span>
  <ng-container *ngIf="con.isCode; else notCodeOld">
    <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto; max-width: 100%;">{{ con.oldValue }}</pre>
  </ng-container>
  <ng-template #notCodeOld>
    <span *ngIf="con.isFile; else elseBlockOld">
      <a (click)="previewFile(con.oldValue, con.isOrg)" class="file-link">View File</a>
    </span>
    <ng-template #elseBlockOld>
      <span *ngIf="con.isLink; else elseOldValueBlock">
        <a [href]="con.oldValue" target="_blank">{{ con.oldValue }}</a>
      </span>
      <ng-template #elseOldValueBlock>
        <ng-container *ngIf="isPasswordField(con.label); else nonPasswordOldValue">
          <span class="password-text">{{ getPasswordDisplayText(con.oldValue, con.newValue) }}</span>
        </ng-container>
        <ng-template #nonPasswordOldValue>
          <ng-container *ngIf="con.label.toLowerCase().includes('permissions'); else nonPermOldValue">
            <div *ngFor="let line of getVisiblePermissions(con.oldValue, idx, 'old')">{{ line }}</div>
            <div *ngIf="hasHiddenPermissions(con.oldValue)">
              <button (click)="togglePermissions(idx, 'old')" class="toggle-btn">
                {{ isExpanded(idx, 'old') ? 'See Less -' : 'See More +' }}
              </button>
              <div *ngIf="isExpanded(idx, 'old')">
                <div *ngFor="let line of getHiddenPermissions(con.oldValue, idx, 'old')">
                  {{ line }}
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #nonPermOldValue>
            <ng-container *ngIf="isAssessmentPlanRoute() && con.label.toLowerCase() === 'rules'; else customAttrsOldValue">
              <div *ngFor="let line of getVisibleChangedOldRules(con.oldValue, con.newValue)">{{ line }}</div>
              <div *ngIf="hasHiddenChangedRules(con.oldValue, con.newValue)">
                <button (click)="togglePermissions(idx, 'old')" class="toggle-btn">
                  {{ isExpanded(idx, 'old') ? 'See Less -' : 'See More +' }}
                </button>
                <div *ngIf="isExpanded(idx, 'old')">
                  <div *ngFor="let line of getHiddenChangedOldRules(con.oldValue, con.newValue)">
                    {{ line }}
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #customAttrsOldValue>
              <ng-container *ngIf="isusercetorgyRoute() && con.label.toLowerCase() === 'custom attrs'; else defaultOldValue">
                <div [innerHTML]="formatCustomAttributesForUpdate(con.oldValue)"></div>
              </ng-container>
              <ng-template #defaultOldValue>
                <ng-container *ngIf="con.label.toLowerCase() === 'labels'; else defaultOldSpan">
                  <div [innerHTML]="getSafeHtml(con.oldValue)"></div>
                </ng-container>
                <ng-template #defaultOldSpan>
                  <span *ngIf="!con.isFile && !con.isLink" [innerHTML]="formatValue(con.label, con.oldValue)"></span>
                  <div *ngIf="con.oldFileUrl">Candidate Details: <a (click)="previewFile(con.oldFileUrl, con.isOrg, 'Candidates_')" class="file-link candidate-file-link" style="color: #007BFF;">View File</a></div>
                </ng-template>
              </ng-template>
            </ng-template>
          </ng-template>
        </ng-template>
      </ng-template>
    </ng-template>
  </ng-template>
                    </div>

                    <!-- NEW VALUE -->
                    <div>
  <span class="label">New Value: </span>
  <ng-container *ngIf="con.isCode; else notCodeNew">
    <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto; max-width: 100%;">{{ con.newValue }}</pre>
  </ng-container>
  <ng-template #notCodeNew>
    <span *ngIf="con.isFile; else elseBlockNew">
      <a (click)="previewFile(con.newValue, con.isOrg)" class="file-link">View File</a>
    </span>
    <ng-template #elseBlockNew>
      <span *ngIf="con.isLink; else elseNewValueBlock">
        <a [href]="con.newValue" target="_blank">{{ con.newValue }}</a>
      </span>
      <ng-template #elseNewValueBlock>
        <ng-container *ngIf="isPasswordField(con.label); else nonPasswordNewValue">
          <span class="password-text">{{ getPasswordDisplayText(con.oldValue, con.newValue) }}</span>
        </ng-container>
        <ng-template #nonPasswordNewValue>
          <ng-container *ngIf="con.label.toLowerCase().includes('permissions'); else nonPermNewValue">
            <div *ngFor="let line of getVisiblePermissions(con.newValue, idx, 'new')">{{ line }}</div>
            <div *ngIf="hasHiddenPermissions(con.newValue)">
              <button (click)="togglePermissions(idx, 'new')" class="toggle-btn">
                {{ isExpanded(idx, 'new') ? 'See Less -' : 'See More +' }}
              </button>
              <div *ngIf="isExpanded(idx, 'new')">
                <div *ngFor="let line of getHiddenPermissions(con.newValue, idx, 'new')">
                  {{ line }}
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #nonPermNewValue>
            <ng-container *ngIf="isAssessmentPlanRoute() && con.label.toLowerCase() === 'rules'; else customAttrsNewValue">
              <div *ngFor="let line of getVisibleChangedNewRules(con.oldValue, con.newValue)">{{ line }}</div>
              <div *ngIf="hasHiddenChangedRules(con.oldValue, con.newValue)">
                <button (click)="togglePermissions(idx, 'new')" class="toggle-btn">
                  {{ isExpanded(idx, 'new') ? 'See Less -' : 'See More +' }}
                </button>
                <div *ngIf="isExpanded(idx, 'new')">
                  <div *ngFor="let line of getHiddenChangedNewRules(con.oldValue, con.newValue)">
                    {{ line }}
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #customAttrsNewValue>
              <ng-container *ngIf="isusercetorgyRoute() && con.label.toLowerCase() === 'custom attrs'; else defaultNewValue">
                <div [innerHTML]="formatCustomAttributesForUpdate(con.newValue)"></div>
              </ng-container>
              <ng-template #defaultNewValue>
                <ng-container *ngIf="con.label.toLowerCase() === 'labels'; else defaultNewSpan">
                  <div [innerHTML]="getSafeHtml(con.newValue)"></div>
                </ng-container>
                <ng-template #defaultNewSpan>
                  <span *ngIf="!con.isFile && !con.isLink" [innerHTML]="formatValue(con.label, con.newValue)"></span>
                  <div *ngIf="con.newFileUrl">Candidate Details: <a (click)="previewFile(con.newFileUrl, con.isOrg, 'Candidates_')" class="file-link candidate-file-link" style="color: #007BFF;">View File</a></div>
                </ng-template>
              </ng-template>
            </ng-template>
          </ng-template>
        </ng-template>
      </ng-template>
    </ng-template>
  </ng-template>
                    </div>
                  </div>
                </ng-container>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #elseBlock>
  <div class="label" style="text-align: center">
    No changes were found to show the revision history logs.
  </div>
</ng-template>